import * as pkg from "vue-toastification";

export const useToast = () => {
  return pkg.useToast();
};
